import { createSelector } from 'reselect'

export const getDialogs = state => state.get('dialogs')

export const getAll = createSelector(
  getDialogs,
  dialogs => dialogs.get('all')
)

// PATIENT DIALOG
const getPatientDialog = createSelector(getAll, allDialogs => allDialogs.get('patient'))
export const isPatientDialogOpened = createSelector(getPatientDialog, patientDialog => patientDialog.get('open'))
export const getPatientDialogData = createSelector(getPatientDialog, patientDialog => patientDialog.get('data'))

// APPOINTMENT DIALOG
const getAppointmentDialog = createSelector(getAll, allDialogs => allDialogs.get('appointment'))
export const isAppointmentDialogOpened = createSelector(
  getAppointmentDialog, appointmentDialog => appointmentDialog.get('open')
)
export const getAppointmentDialogData = createSelector(
  getAppointmentDialog, appointmentDialog => appointmentDialog.get('data')
)

// TREATMENT DIALOG
const getTreatmentDialog = createSelector(getAll, allDialogs => allDialogs.get('treatment'))
export const isTreatmentDialogOpened = createSelector(
  getTreatmentDialog, treatmentDialog => treatmentDialog.get('open')
)
export const getTreatmentDialogData = createSelector(
  getTreatmentDialog, treatmentDialog => treatmentDialog.get('data')
)

// INSURANCE COMPANY DIALOG
const getInsuranceCompanyDialog = createSelector(getAll, allDialogs => allDialogs.get('insuranceCompany'))
export const isInsuranceCompanyDialogOpened = createSelector(
  getInsuranceCompanyDialog, insuranceCompanyDialog => insuranceCompanyDialog.get('open')
)
export const getInsuranceCompanyDialogData = createSelector(
  getInsuranceCompanyDialog, insuranceCompanyDialog => insuranceCompanyDialog.get('data')
)

// COPAID PAYMENT DIALOG
const getCopaidPaymentDialog = createSelector(getAll, allDialogs => allDialogs.get('copaidPayment'))
export const isCopaidPaymentDialogOpened = createSelector(
  getCopaidPaymentDialog, copaidPaymentDialog => copaidPaymentDialog.get('open')
)
export const getCopaidPaymentDialogData = createSelector(
  getCopaidPaymentDialog, copaidPaymentDialog => copaidPaymentDialog.get('data')
)
